

import React, {Component} from "react";

class SurfaceFinish extends Component{

    render() {
        return(
            <div className="container-fluid">
                HASL（有鉛はんだレベラー）HASL-RoHs（鉛フリーはんだレベラー）ENIG-RoHs（無電解金メッキ）

            </div>
        );
    }
}
export default SurfaceFinish;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/SurfaceFinish.js